
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Die erste Welle`}</h2>
    <p>{`In der ersten Welle von Ende Februar bis Anfang Juni 2020 gibt es Häufungen von Infektionen vor allem in den grenznahen Gemeinden im Süden – in den Kantonen Genf, Graubünden, Tessin, Waadt und Wallis. Nur vereinzelt sind Ausreisser in der Deutschschweiz zu finden. Es handelt sich dabei um kleine Gemeinden, bei denen schon wenige Infektionen stark ins Gewicht fallen. Diese Ausreisser kommen zufällig zustande. Allerdings sind die Fallzahlen aus der ersten Welle stark unterschätzt – weil vergleichsweise wenig Corona-Tests gemacht wurden. Laut offiziellen Zahlen des BAG gibt es nur rund 30’000 Corona-Infektionen und 2000 Todesfälle.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;